<template>
    <rkm-modal
        :loading="loading"
        title='Viagens pré agendadas'
        extraLarge
        ref="Modal"
        @save="$refs.Form.save()"
    >
        <Form
            :form="form"
            ref="Form"
            @save="handleExit"
        />

        <template v-slot:footer>
            <rkm-button
                @click="handleExit"
            >
                Fechar
            </rkm-button>
            <rkm-button
                color="primary"
                @click="handleAtribuir"
                :disabled="handleDisabled()"
            >
                Atribuir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        handleAtribuir() {

            const selecionado = this.form.preAgendamentos.find(agendamento => agendamento.selecionado)

            this.$emit('handlePreAgendar', selecionado)
            this.$refs.Modal.hide()
        },
        handleDisabled() {

            return this.form.preAgendamentos.find(agendamento => agendamento.selecionado) ? false : true
        }
    },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
    }
}
</script>